import React from 'react';
import AlertType from '@app/model/alert/AlertType';
import PriceComparisonAlertExecutionFragment
	from '@app/site/secured/alert-execution/fragment/price-comparison/PriceComparisonAlertExecutionFragment';
import CompetitorsPriceRateAlertExecutionFragment
	from '@app/site/secured/alert-execution/fragment/competitors-price-rate/CompetitorsPriceRateAlertExecutionFragment';
import { useSelectedCompanyHotel } from '@app/site/secured/provider/useSelectedCompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';


const AlertExecutionFragment: React.FunctionComponent<{
	alertExecution: AlertExecution,
	isInDrawer?: boolean
}> = ({ alertExecution, isInDrawer = false }) => {


	const companyHotel = useSelectedCompanyHotel();

	if (alertExecution && !!companyHotel) {
		return <div>
			{alertExecution.alertOutput.alert.type === AlertType.PRICE_COMPARISON &&
				<PriceComparisonAlertExecutionFragment companyHotel={companyHotel} alertExecution={alertExecution}
																							 isInDrawer={isInDrawer} />}
			{alertExecution.alertOutput.alert.type === AlertType.COMPETITORS_PRICE_RATE &&
				<CompetitorsPriceRateAlertExecutionFragment companyHotel={companyHotel} alertExecution={alertExecution}
																										isInDrawer={isInDrawer} />}
		</div>;
	}

	return <></>;
};

export default AlertExecutionFragment;